<template>
  <div class="foldout">
    <button class="foldout__button" @click="toggleContent">
      <span class="foldout__label">{{ label }}</span>
      <span class="foldout__icon" :class="{ 'rotate-icon': showContent }">
        <img src="@/assets/icons/plus.svg" alt="Show more" />
      </span>
    </button>
    <transition name="foldout__transition" mode="out-in">
      <div
        v-if="showContent"
        class="foldout__text"
        :style="{ maxHeight: textHeight + 'px' }"
      >
        <span class="foldout__span">
          {{ description }}
          <!--          <router-link-->
          <!--            :to="{ name: 'ProjectDetails', params: { slug: slug } }"-->
          <!--            class="foldout__link"-->
          <!--          >-->
          <!--            Go to project-->
          <!--            <span class="foldout__arrow">-->
          <!--              <img src="@/assets/icons/arrow.svg" alt="Link to project" />-->
          <!--            </span>-->
          <!--          </router-link>-->
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "FoldOut",
  props: {
    description: String,
    label: String,
    slug: String,
  },
  data() {
    return {
      showContent: false,
      textHeight: 0,
    };
  },
  methods: {
    toggleContent() {
      this.showContent = !this.showContent;
      this.updateTextHeight();
    },
    updateTextHeight() {
      this.$nextTick(() => {
        this.textHeight = this.showContent
          ? this.$el.querySelector(".foldout__text").scrollHeight
          : 0;
      });
    },
  },
};
</script>

<style scoped>
.foldout {
  margin-left: 9px;
  margin-right: 9px;
  margin-top: 12px;
}

.foldout__button {
  width: 100%;
  border-radius: 20px;
  background-color: var(--color-black);
  border: none;
  position: relative;
  color: white;
  font-family: "Titillium Regular", sans-serif;
  font-size: 18px;
  line-height: 24px;
  text-align: left;
  cursor: pointer;
}

.foldout__label {
  padding-left: 8px;
}

.foldout__icon {
  color: white;
  position: absolute;
  right: 4px;
  transition: transform 0.3s ease; /* Add transition for smooth rotation */
}

.rotate-icon {
  transform: rotate(-45deg); /* Rotate the icon when content is shown */
}

.foldout__text {
  background-color: var(--color-yellow);
  color: var(--color-text-dark);
  font-family: "Titillium Regular", sans-serif;
  font-size: 18px;
  padding: 18px;
  margin-left: 8px;
  margin-right: 8px;
  transition: max-height 0.3s ease-out, opacity 0.3s ease 0.1s; /* Use max-height for height transition and opacity for fade transition */
  overflow: hidden; /* Ensure that content is hidden when collapsed */
}

.foldout__span {
  transition: opacity 0.3s ease 0.1s; /* Add transition for opacity */
}

.foldout__link {
  color: var(--color-text-dark);
  text-decoration: none;
  font-weight: 600;
  display: block;
}

.foldout__arrow {
  margin-left: 4px;
}
.foldout__transition-enter-active,
.foldout__transition-leave-active {
  transition: max-height 0.3s ease-out, opacity 0.3s ease 0.1s; /* Use max-height for height transition and opacity for fade transition */
}

.foldout__transition-enter,
.foldout__transition-leave-to {
  max-height: 300px;
}

.foldout__transition-enter-active .foldout__span,
.foldout__transition-leave-active .foldout__span {
  opacity: 0; /* Initially set opacity to 0 during enter/leave transition */
}
</style>
